var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreetWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 19H20.693L14.937 3.648C14.8653 3.45745 14.7372 3.29332 14.5698 3.17752C14.4024 3.06173 14.2036 2.9998 14 3H10C9.79643 2.9998 9.59764 3.06173 9.4302 3.17752C9.26277 3.29332 9.13466 3.45745 9.063 3.648L3.307 19H2C1.73478 19 1.48043 19.1054 1.29289 19.2929C1.10536 19.4804 1 19.7348 1 20C1 20.2652 1.10536 20.5196 1.29289 20.7071C1.48043 20.8946 1.73478 21 2 21H22C22.2652 21 22.5196 20.8946 22.7071 20.7071C22.8946 20.5196 23 20.2652 23 20C23 19.7348 22.8946 19.4804 22.7071 19.2929C22.5196 19.1054 22.2652 19 22 19ZM10.693 5H13.307L14.432 8H9.568L10.693 5ZM8.818 10H15.182L15.932 12H8.068L8.818 10ZM5.443 19L7.318 14H16.682L18.557 19H5.443Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreetWarning);
export default __webpack_public_path__ + "static/media/street-warning.bc6b0cddcce830a792b4162b91ffc511.svg";
export { ForwardRef as ReactComponent };